import React from "react";
import "./css/reels.css";

const InstagramReels = () => {
    const reels = [
        "DWGqd3kDZsE",
        "DVd-yuHDGmk",
        "DLqGQs4N08u",
        "DMLWpTJtRiR"
    ];

    return (
        <div className="container">

            <div className="grid">
                {reels.map((id, index) => (
                    <div className="card" key={index}>
                        <iframe
                            src={`https://www.instagram.com/reel/${id}/embed`}
                            title={`Reel ${index}`}
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                ))}
            </div>

            {/* Profile */}
            <div className="profile">
                <div className="profile-card">
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                        alt="Instagram"
                        className="insta-logo"
                    />

                    <h4>@dedicationschoolofexcellence</h4>
                    <p>Latest updates • Reels • Activities</p>

                    <a
                        href="https://www.instagram.com/dedicationschoolofexcellence/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="follow-btn"
                    >
                        Follow on Instagram
                    </a>
                </div>
            </div>
        </div>
    );
};

export default InstagramReels;